
import * as React from 'react';
import { Navbar } from 'react-bootstrap';

import logo from './logo.png';
import './header.css';

interface HeaderProps {
	tableName: string
};

const Header: React.SFC<HeaderProps> = props => {
	return (
		<Navbar>
			<Navbar.Header>
				<Navbar.Brand >
					<a href="https://www.timetonic.com/live">
						<img src={logo} alt="Timetonic" className="Header-logo" />
					</a>
				</Navbar.Brand>
				<Navbar.Text> {props.tableName} </Navbar.Text>
			</Navbar.Header>
		</Navbar>
	);
};
	
export default Header;


// WEBPACK FOOTER //
// ./src/components/header/index.tsx